/**
 * Technology & Digital Reach Translations Module (Portuguese)
 * 
 * Contains: Website Analytics, Social Media, LEADER Magazine, Technology Trends
 * 
 * @module technology
 * @language pt
 */

export const technology = {
  technologyFuture: {
    pageTitle: "Tecnologia e Alcance Digital",
    pageSubtitle: "JCI.cc • Redes Sociais • Revista LEADER | 260K+ seguidores, 70+ países"
  },
  technologyRole: {
    title: "Papel da Tecnologia",
    subtitle: "Como a JCI usa a tecnologia para conectar e empoderar jovens líderes",
    new: "NOVO"
  },
  programs: {
    jciWebsite: "Site JCI.cc",
    website: "Site",
    socialMedia: "Redes Sociais",
    social: "Social",
    leaderMagazine: "Revista LEADER",
    magazine: "Revista",
    activeUsers: "Usuários Ativos",
    pageViews: "Visualizações de Página",
    avgSession: "Sessão Média",
    bounceRate: "Taxa de Rejeição",
    returnVisitors: "Visitantes Recorrentes",
    mobileAccess: "acesso via móvel",
    mobileFirstApproach: "Abordagem mobile-first essencial",
    deviceBreakdown: "Divisão por Dispositivo",
    trafficSources: "Fontes de Tráfego",
    topGeographicSources: "Principais Fontes Geográficas",
    largest: "Maior",
    topPagesVisited: "Páginas Mais Visitadas",
    combinedFollowers: "Seguidores Combinados",
    monthlyImpressions: "Impressões Mensais",
    organicGrowth: "Crescimento Orgânico",
    avgEngagement: "Engajamento Médio",
    followers: "Seguidores",
    topContent: "Conteúdo Principal",
    topVideo: "Vídeo Principal",
    views: "visualizações",
    retention: "retenção",
    totalReaders: "Leitores Totais",
    bookVisits: "Visitas ao Livro",
    avgReadTime: "Tempo Médio de Leitura",
    countries: "Países",
    keyInsight: "Insight Chave",
    readersPerIssue: "Leitores por Edição (7 Edições, Jan-Out 2025)",
    readTimeTrend: "Tendência de Tempo de Leitura (Engajamento Crescente)",
    deviceAccess: "Acesso por Dispositivo",
    regionalReach: "Alcance Regional",
    contentThemes: "Temas de Conteúdo",
    devices: {
      desktopLaptop: "Desktop/Laptop",
      mobilePhone: "Celular",
      tablet: "Tablet"
    },
    trafficSourceTypes: {
      organicSearch: "Busca Orgânica",
      direct: "Direto",
      referral: "Referência",
      paid: "Pago",
      goodSeoVisibility: "Boa visibilidade SEO",
      strongBrandRecognition: "Forte reconhecimento de marca",
      socialPartnerships: "Social + parcerias",
      limitedCampaigns: "Campanhas limitadas"
    },
    topPagesData: {
      aboutJci: "Sobre a JCI",
      newsEvents: "Notícias e Eventos",
      whatWeDo: "O Que Fazemos",
      programsPage: "Programas",
      getInvolved: "Participe",
      discoveringOrg: "Pessoas descobrindo a org",
      engagementSeeking: "Buscando engajamento",
      programInterest: "Interesse em programas",
      actionOriented: "Visitantes orientados à ação",
      ctaMomentum: "Momentum de chamada para ação"
    }
  },
  socialMediaData: {
    communityHub: "Centro de Comunidade",
    visualStorytelling: "Narrativa Visual",
    thoughtLeadership: "Liderança de Pensamento",
    longFormContent: "Conteúdo de Formato Longo",
    fastestGrowth: "Crescimento Mais Rápido",
    consistentGrowth: "Crescimento Consistente",
    eventHighlights: "Destaques de eventos",
    memberStories: "Histórias de membros",
    campaigns: "Campanhas",
    reels: "Reels (3x engajamento)",
    visualStories: "Histórias visuais",
    leadershipInsights: "Insights de liderança",
    partnerships: "Parcerias",
    trainingSessions: "Sessões de treinamento",
    reach: "alcance",
    engagement: "engajamento",
    impressions: "impressões",
    interactions: "interações",
    watchTime: "tempo de visualização",
    whatIsJci: "O que é JCI?"
  },
  futureSkills: {
    communicationPublicSpeaking: "Comunicação e Oratória",
    communicationDesc: "Essencial para liderança e influência",
    criticalThinking: "Pensamento Crítico e Resolução de Problemas",
    criticalThinkingDesc: "Habilidades analíticas para desafios complexos",
    conflictResolution: "Resolução de Conflitos e Negociação",
    conflictResolutionDesc: "Gerenciar disputas e construir consenso",
    projectManagement: "Gestão de Projetos",
    projectManagementDesc: "Planejar e executar iniciativas eficazmente",
    digitalTechLiteracy: "Alfabetização Digital e Tecnológica",
    digitalTechDesc: "Entender ferramentas tecnológicas modernas",
    financialLiteracy: "Alfabetização Financeira",
    financialLiteracyDesc: "Gestão de orçamentos e planejamento financeiro",
    interculturalCommunication: "Comunicação Intercultural",
    interculturalDesc: "Trabalhar eficazmente entre culturas",
    advocacyInfluence: "Advocacia e Influência",
    advocacyDesc: "Impulsionar mudanças através da persuasão"
  },
  technology: {
    title: "Tecnologia e Futuro",
    subtitle: "Adoção tecnológica e tendências de inovação futura",
    memberProfile: "Perfil Tecnológico do Membro",
    engagementMembers: "Engajamento de Membros",
    aiInLeadership: "IA na Liderança",
    transformative: "Transformador",
    aiDescription: "Ferramentas de IA para tomada de decisão, aprendizado personalizado e automação estão remodelando como jovens líderes se desenvolvem e lideram.",
    digitalFirstSkills: "Habilidades Digitais Primeiro",
    critical: "Crítico",
    digitalDescription: "Alfabetização de dados, marketing digital, programação e cibersegurança são agora habilidades essenciais para avanço profissional.",
    sustainabilityGreenTech: "Sustentabilidade e Tech Verde",
    essential: "Essencial",
    sustainabilityDescription: "Tech climática, energia renovável e soluções de economia circular impulsionando a sustentabilidade ambiental.",
    mentalHealthTech: "Tech de Saúde Mental",
    growing: "Crescente",
    mentalHealthDescription: "Apps de bem-estar mental, plataformas de teleterapia e chatbots de IA fornecendo suporte acessível de saúde mental.",
    keyFocusAreas: "Áreas de Foco Chave",
    source: "Fonte",
    trendsResearchSources: "Fontes de Pesquisa de Tendências",
    futureSkillsPriorities: "Prioridades de Habilidades Futuras 2025",
    futureSkillsSubtitle: "Competências essenciais identificadas por membros da JCI para desenvolvimento de liderança e sucesso profissional",
    priority: "Prioridade",
    skillsDevelopmentFramework: "Framework de Desenvolvimento de Habilidades",
    skillsFrameworkDesc: "Essas prioridades guiam os programas de treinamento, workshops e iniciativas de desenvolvimento de liderança da JCI. Os membros identificaram essas competências como as mais críticas para navegar os desafios em evolução de 2025 e além, com ênfase particular em comunicação, pensamento crítico e alfabetização digital.",
    veryHigh: "Muito Alta",
    high: "Alta",
    medium: "Média",
    mediumHigh: "Média-Alta",
    emerging: "Emergente",
    // AI Focus Areas
    aiAugmentedDecision: "Tomada de decisão aumentada por IA",
    personalizedLearning: "Trilhas de aprendizado personalizadas",
    automatedAnalytics: "Análises automatizadas",
    ethicalAiGovernance: "Governança ética de IA",
    // Digital Skills Focus Areas
    dataLiteracy: "Alfabetização de dados",
    digitalMarketing: "Marketing digital",
    programmingBasics: "Fundamentos de programação",
    cybersecurityAwareness: "Conscientização em cibersegurança",
    // Green Tech Focus Areas
    climateTechnology: "Tecnologia climática",
    renewableEnergy: "Energia renovável",
    circularEconomy: "Economia circular",
    esgMeasurement: "Medição ESG",
    // Mental Health Tech Focus Areas
    wellnessApplications: "Aplicativos de bem-estar",
    teletherapyPlatforms: "Plataformas de teleterapia",
    aiSupportChatbots: "Chatbots de suporte com IA",
    stressManagementTools: "Ferramentas de gestão de estresse"
  }
} as const;
